import { render, staticRenderFns } from "./PriceTierDropdown.vue?vue&type=template&id=4127527e&lang=pug&"
import script from "./PriceTierDropdown.vue?vue&type=script&lang=js&"
export * from "./PriceTierDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports